<ngb-toast *ngFor="let toast of toasts"
           [autohide]="toast.autohide"
           [delay]="toast.delay"
           (hidden)="removeToast(toast)"
           [ngClass]="toast.classname">

  <ng-template *ngIf="toast?.header" ngbToastHeader>
    {{ toast.header }}
  </ng-template>

  <div class="ngb-toast-body">
    <div class="ngb-toast-icon">
      <i class={{toast.icon}}></i>
    </div>
    <div class="ngb-toast-message">
      {{ toast.text || 'No content available' }}
    </div>
  </div>


  <footer class="ngb-toast-footer"  *ngIf="toast.footerAction">
    <button *ngIf="toast.footerAction" (click)="toast.footerAction()" class="btn btn-link">
      {{ toast.footerText || 'Action' }}
    </button>
  </footer>

</ngb-toast>

<!-- <ngb-toast
  *ngFor="let toast of toasts"
  [autohide]="toast.autohide"
  [delay]="toast.delay"
  (hidden)="removeToast(toast)"
  [class]="toast.classname">
 <ng-template *ngIf="toast?.header" ngbToastHeader>
    {{ toast.header }}
  </ng-template>

  <div class="ngb-toast-body">
    <div class="ngb-toast-icon">
      <i [class]="toast.icon"></i>
    </div>
    <div class="ngb-toast-message">
      {{ toast.text }}
    </div>
  </div>

  <footer class="ngb-toast-footer" *ngIf="toast?.footerAction">
    <button *ngIf="toast.footerAction" (click)="toast.footerAction()" class="btn btn-link">
      {{ toast.footerText || 'Action' }}
    </button>
  </footer>
</ngb-toast> -->